module.exports = __webpack_public_path__ + "static/media/draft-drip.79662d69.svg";